import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Chip } from '@mui/material';
import { SupplierConnectionState, SupplierDirectoryLab } from 'models/supplier-request';

type SupplierConnectionActionProps = {
    lab: SupplierDirectoryLab;
    onRequest: (lab: SupplierDirectoryLab) => void;
};

/** DD-3662: where the browsing lab stands with a supplier, or the button to ask it. */
const SupplierConnectionAction: FC<SupplierConnectionActionProps> = ({ lab, onRequest }) => {
    const { t: translate } = useTranslation(['client-directory']);
    if (lab.connection === SupplierConnectionState.CONNECTED) {
        return <Chip size="small" color="success" label={translate('client-directory:SUPPLIER_CONNECTED')} />;
    }
    if (lab.connection === SupplierConnectionState.PENDING) {
        return <Chip size="small" color="warning" label={translate('client-directory:SUPPLIER_REQUEST_PENDING')} />;
    }
    return (
        <Button
            variant="contained"
            size="small"
            onClick={() => onRequest(lab)}
            data-test={`supplier-browser.request-${lab._id}`}
        >
            {translate('client-directory:REQUEST_SUPPLIER')}
        </Button>
    );
};

export default SupplierConnectionAction;
